function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from './spzaComponent';
import { Constants } from '../utils/constants';
import { logger } from '@src/logger';
import classNames from 'classnames';
const minimumLoatimeForTelemetry = 10000;
const processedImageLoadedSrcList = {};
const processedImageErrorSrcList = {};
export function onImageLoaded(src, startTime) {
    const timeTaken = Date.now() - startTime;
    if (!processedImageLoadedSrcList[`${src}`] && timeTaken > minimumLoatimeForTelemetry) {
        processedImageLoadedSrcList[`${src}`] = true;
        const payload = {
            page: src,
            action: Constants.Telemetry.Action.ImageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.End,
            details: `Elapsed time: ${timeTaken} ms`
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    }
}
export function onImageErrored(src, startTime) {
    if (!processedImageErrorSrcList[`${src}`]) {
        processedImageErrorSrcList[`${src}`] = true;
        const payload = {
            page: src,
            action: Constants.Telemetry.Action.ImageLoad,
            actionModifier: Constants.Telemetry.ActionModifier.Error,
            details: `Elapsed time: ${Date.now() - startTime} ms`
        };
        logger.error(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    }
}
export class TelemetryImage extends SpzaComponent {
    getAlt(alt, title, isVideo) {
        if (alt) {
            return alt;
        } else if (title) {
            return title + ' image';
        } else if (isVideo) {
            return 'play video';
        } else {
            return 'image';
        }
    }
    componentDidMount() {
        // since componentDidMount is only called at client side after the initial client side rendering
        // is finished which would be consistent with the server side rendering result.
        // then readyForNonInitialRendering is set to true here which would trigger another round of client side rendering.
        this.setState({
            readyForNonInitialRendering: true,
            startTime: Date.now()
        });
    }
    renderImpl() {
        const { title, alt, isVideo, className, src, onError, imgClassName } = this.props;
        const { startTime } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: classNames('delayLoadImage', 'telemetry', className),
            children: this.state.readyForNonInitialRendering ? /*#__PURE__*/ _jsx("img", {
                itemProp: this.microTaggingItemPropName,
                src: src,
                alt: this.getAlt(alt, title, isVideo),
                onLoad: ()=>onImageLoaded(src, startTime),
                onError: (event)=>{
                    onImageErrored(src, startTime);
                    onError === null || onError === void 0 ? void 0 : onError(event);
                },
                "aria-label": this.getAlt(alt, title, isVideo),
                className: imgClassName || null
            }) : src
        });
    }
    constructor(props){
        super(props), _define_property(this, "microTaggingItemPropName", '');
        const { itemPropName } = this.props;
        this.state = {
            readyForNonInitialRendering: false,
            startTime: 0
        };
        this.microTaggingItemPropName = itemPropName || 'thumbnailUrl';
    }
}
